import React from 'react'
import PlacesAutocomplete, { geocodeByAddress } from 'react-places-autocomplete'

// Async options so google maps can load
const defaultSearchOptions = () => ({
  location: new window.google.maps.LatLng(40.786415, -73.97467), // TODO: ADD area via env variables
  radius: 20000,
  types: ['address'],
  componentRestrictions: { country: ['us'] }
})

const MapAddressComponent = ({
  handleChange,
  handleSelection,
  value,
  searchOptions = defaultSearchOptions(),
  name
}) => {
  const handleSelect = place => {
    geocodeByAddress(place).then(results => {
      const components = results[0]
        ? results[0].address_components.reduce(function(obj, item) {
            item.types.forEach(function(type) {
              obj[type] = item.long_name
            })
            return obj
          }, {})
        : {}
      components.street_number = components.street_number || ''
      components.route = components.route || ''

      handleChange(components.street_number + ' ' + components.route)
      handleSelection({ [name]: results[0].formatted_address, components })
    })
  }

  return (
    <PlacesAutocomplete
      value={value}
      onChange={handleChange}
      onSelect={handleSelect}
      searchOptions={searchOptions}>
      {({ getInputProps, suggestions, getSuggestionItemProps, loading }) => (
        <div className="cookunity__address_map_autocomplete">
          <input
            {...getInputProps({
              placeholder: 'Search Places ...',
              className: 'cookunity__address_input',
              name
            })}
          />
          <div
            className={`cookunity__address_dropdown ${
              suggestions.length ? '' : 'empty'
            }`}>
            {loading && <div>Loading...</div>}
            {suggestions.map(suggestion => (
              <div
                {...getSuggestionItemProps(suggestion, {
                  className: suggestion.active
                    ? 'suggestion-item active'
                    : 'suggestion-item'
                })}>
                <span>{suggestion.description}</span>
              </div>
            ))}
          </div>
        </div>
      )}
    </PlacesAutocomplete>
  )
}
export default MapAddressComponent



// WEBPACK FOOTER //
// ./src/modules/Checkout/DeliveryDetails/MapAddressSelector.js